// extracted by mini-css-extract-plugin
export default {"SuccessMessage":"SuccessMessage_SuccessMessage__6Yx1d","hasFixWidth":"SuccessMessage_hasFixWidth__tb5Zb","grow":"SuccessMessage_grow__CcpBB"};